import * as React from 'react';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import * as types from '../../types';
import GenExport from '../export/GenExport';

export interface ITrackRisksReportClsProps extends types.IBaseComponentProps {
}

export interface ITrackRisksReportClsState {
}
export class TrackRisksReportClsState implements ITrackRisksReportClsState {
}

export default class TrackRisksReportCls extends React.Component<ITrackRisksReportClsProps, TrackRisksReportClsState> {
    constructor(props: ITrackRisksReportClsProps, state: ITrackRisksReportClsState) {
        super(props);
        this.state = new TrackRisksReportClsState();
    }

    public render(): React.ReactElement<ITrackRisksReportClsProps> {
        return (
            <React.Fragment>
                <Pivot>
                    <PivotItem headerText="Export to Excel" itemKey="Export to Excel">
                        {this.renderGenExport()}
                    </PivotItem>
                </Pivot>
            </React.Fragment>
        );
    }

    private renderGenExport(): React.ReactElement<types.IWebPartComponentProps> {

        const isSuperUserPermission: boolean = this.isSuperUser();
        return (
            <div>
                <div style={{ paddingTop: "10px" }}>
                    {(isSuperUserPermission === true) &&
                        <GenExport
                            {...this.props}
                            moduleName="TrackRisks"

                        />
                    }
                    {
                        (isSuperUserPermission === false) &&
                        <div style={{ fontSize: '14px', color: 'navy', fontStyle: 'italic', paddingTop: '8px', paddingLeft: '5px' }}>
                            Export to Excel function is only available to the Super User.
                        </div>
                    }

                </div>
            </div>
        );

    }

    private isSuperUser(): boolean {
        return this.props.userPermissions.UserIsSystemAdmin();
    }
}